// import React, { useEffect, useState } from "react";
// import DashboardLayout from "../../components/layouts/DashboardLayout";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../utils/axiosInstance";
// import { API_PATHS } from "../../utils/apiPaths";
// import { LuFileSpreadsheet } from "react-icons/lu";
// import TaskStatusTabs from "../../components/TaskStatusTabs";
// import TaskCard from "../../components/Cards/TaskCard";
// import toast from "react-hot-toast";

// const ManageTasks = () => {
//   const [allTasks, setAllTasks] = useState([]);
//   const [tabs, setTabs] = useState([]);
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   // Récupération sécurisée de toutes les tâches
//   const getAllTasks = async () => {
//     try {
//       const response = await axiosInstance.get(API_PATHS.TASKS.GET_ALL_TASKS, {
//         params: filterStatus === "All" ? {} : { status: filterStatus },
//       });

//       const tasks = response.data?.tasks || [];
//       setAllTasks(tasks);
//       console.log(response.data);
//       const statusSummary = response.data?.statusSummary || {};
//       setTabs([
//         { label: "All", count: statusSummary.all || 0 },
//         { label: "enattente", count: statusSummary.pendingTask || 0 },
//         { label: "encours", count: statusSummary.inProgressTask || 0 },
//         { label: "terminé", count: statusSummary.completedTask || 0 },
//         { label: "enretard", count: statusSummary.dueDateTasks || 0 },
//       ]);
//     } catch (error) {
//       console.error("Erreur de récupération des tâches", error);
//       setAllTasks([]);
//       setTabs([]);
//     }
//   };
//   const handleClick = (taskData) => {
//     navigate("/admin/tasks", { state: { taskId: taskData._id } });
//   };

//   const handleDownloadReport = async () => {
//     try {
//       const response = await axiosInstance.get(API_PATHS.REPORTS.EXPORT_TASKS, {
//         responseType: "blob",
//       });

//       const url = window.URL.createObjectURL(new Blob([response?.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "tasks-report.xlsx");
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       toast.success("Rapport téléchargé avec succès !");
//     } catch (error) {
//       console.error("Erreur de téléchargement du rapport", error);
//       toast.error(
//         "Erreur lors du téléchargement du rapport. Veuillez réessayer !"
//       );
//     }
//   };

//   useEffect(() => {
//     getAllTasks(filterStatus);
//   }, [filterStatus]);

//   return (
//     <DashboardLayout activeMenu="Manage Tasks">
//       <div className="my-5">
//         <div className="flex flex-col lg:flex-row lg:items-center justify-between">
//           <div className="flex items-center justify-between gap-3">
//             <h2 className="text-xl md:text-xl font-medium">MES TÂCHES</h2>
//             <button
//               className="flex lg:flex download-btn"
//               onClick={handleDownloadReport}
//             >
//               <LuFileSpreadsheet className="text-lg" />
//               Télécharger le rapport
//             </button>
//           </div>
//           {tabs?.[0]?.count > 0 && (
//             <div className="flex items-center gap-3">
//               <TaskStatusTabs
//                 tabs={tabs}
//                 activeTab={filterStatus}
//                 setActiveTab={setFilterStatus}
//               />
//             </div>
//           )}
//         </div>

//         {loading ? (
//           <div role="status" class="max-w-sm animate-pulse">
//             <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
//             <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
//             <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
//             <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
//             <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
//             <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
//             <span class="sr-only">Chargement des donnees...</span>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
//             {/* {allTasks?.map((item) => (
//               <TaskCard
//                 key={item._id}
//                 title={item.title}
//                 description={item.description}
//                 priority={item.priority}
//                 status={item.status}
//                 progress={item.progress}
//                 createdAt={item.createdAt}
//                 dueDate={item.dueDate}
//                 assignedTo={
//                   item.assignedTo?.map((user) => user.profileImageUrl) || []
//                 }
//                 attachmentCount={item.attachments?.length || 0}
//                 completedTodoCount={item.completedTodoCount || 0}
//                 todoCheckList={item.todoCheckList || []}
//                 onClick={() => handleClick(item)}
//               />
//             ))} */}
//             {allTasks?.map((item) => (
//               <TaskCard
//                 key={item?._id}
//                 title={item?.title || ""}
//                 description={item?.description || ""}
//                 priority={item?.priority || "faible"}
//                 status={item?.status || "enattente"}
//                 progress={item?.progress || 0}
//                 createdAt={item?.createdAt}
//                 dueDate={item?.dueDate}
//                 assignedTo={
//                   Array.isArray(item?.assignedTo)
//                     ? item.assignedTo.map((user) => user.profileImageUrl)
//                     : []
//                 }
//                 attachmentCount={
//                   Array.isArray(item?.attachments) ? item.attachments.length : 0
//                 }
//                 completedTodoCount={item?.completedTodoCount || 0}
//                 todoCheckList={
//                   Array.isArray(item?.todoCheckList) ? item.todoCheckList : []
//                 }
//                 onClick={() => handleClick(item)}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default ManageTasks;

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import { LuFileSpreadsheet } from "react-icons/lu";
import TaskStatusTabs from "../../components/TaskStatusTabs";
import TaskCard from "../../components/Cards/TaskCard";
import toast from "react-hot-toast";

const ManageTasks = () => {
  const [allTasks, setAllTasks] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [filterStatus, setFilterStatus] = useState("All");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getAllTasks = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(API_PATHS.TASKS.GET_ALL_TASKS, {
        params: filterStatus === "All" ? {} : { status: filterStatus },
      });

      const tasks = Array.isArray(response.data?.tasks) ? response.data.tasks : [];
      setAllTasks(tasks);
      const statusSummary = response.data?.statusSummary || {};
      setTabs([
        { label: "All", count: statusSummary.all || 0 },
        { label: "enattente", count: statusSummary.pendingTask || 0 },
        { label: "encours", count: statusSummary.inProgressTask || 0 },
        { label: "terminé", count: statusSummary.completedTask || 0 },
        { label: "enretard", count: statusSummary.dueDateTasks || 0 },
      ]);
    } catch (error) {
      console.error("Erreur de récupération des tâches", error);
      setAllTasks([]);
      setTabs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (taskData) => {
    navigate("/admin/tasks", { state: { taskId: taskData?._id } });
  };

  const handleDownloadReport = async () => {
    try {
      const response = await axiosInstance.get(API_PATHS.REPORTS.EXPORT_TASKS, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "tasks-report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Rapport téléchargé avec succès !");
    } catch (error) {
      console.error("Erreur de téléchargement du rapport", error);
      toast.error("Erreur lors du téléchargement du rapport. Veuillez réessayer !");
    }
  };

  useEffect(() => {
    getAllTasks();
  }, [filterStatus]);

  return (
    <DashboardLayout activeMenu="Manage Tasks">
      <div className="my-5">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between">
          <div className="flex items-center justify-between gap-3">
            <h2 className="text-xl md:text-xl font-medium">MES TÂCHES</h2>
            <button
              className="flex lg:flex download-btn"
              onClick={handleDownloadReport}
            >
              <LuFileSpreadsheet className="text-lg" />
              Télécharger le rapport
            </button>
          </div>
          {tabs?.[0]?.count > 0 && (
            <div className="flex items-center gap-3">
              <TaskStatusTabs
                tabs={tabs}
                activeTab={filterStatus}
                setActiveTab={setFilterStatus}
              />
            </div>
          )}
        </div>

        {loading ? (
          <div role="status" className="max-w-sm animate-pulse">
            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
            <span className="sr-only">Chargement des données...</span>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
             
             {allTasks?.map((item) => (
              <TaskCard
                key={item?._id}
                title={item?.title || ""}
                description={item?.description || ""}
                priority={item?.priority || "faible"}
                status={item?.status || "enattente"}
                progress={item?.progress || 0}
                createdAt={item?.createdAt}
                dueDate={item?.dueDate}
                assignedTo={Array.isArray(item?.assignedTo)
                  ? item.assignedTo.map((user) => user?.profileImageUrl).filter(Boolean)
                  : []}
                attachmentCount={Array.isArray(item?.attachments) ? item.attachments.length : 0}
                completedTodoCount={item?.completedTodoCount || 0}
                todoCheckList={Array.isArray(item?.todoCheckList) ? item.todoCheckList : []}
                onClick={() => handleClick(item)}
              />
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ManageTasks;
